import { render, staticRenderFns } from "./PageFormSubmission.vue?vue&type=template&id=2ab82996&scoped=true&"
import script from "./PageFormSubmission.vue?vue&type=script&lang=js&"
export * from "./PageFormSubmission.vue?vue&type=script&lang=js&"
import style0 from "./PageFormSubmission.vue?vue&type=style&index=0&id=2ab82996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab82996",
  null
  
)

export default component.exports